/**
 * Registro do service worker (PWA). Silencioso por design: se o browser não
 * suporta SW ou o registro falha, o app continua funcionando online — o SW só
 * acelera o app-shell, nunca é requisito de funcionamento.
 */
export function registerServiceWorker(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  // Só registra o SW em produção. Em dev (vite dev), registrar o SW faz o
  // navegador servir um app-shell cacheado antigo em vez do código novo
  // (cache-shadow) — anti-padrão que mascara mudanças no preview. Em dev,
  // além de não registrar, removemos qualquer SW previamente instalado.
  if (!import.meta.env.PROD) {
    navigator.serviceWorker.getRegistrations?.().then((regs) => regs.forEach((r) => r.unregister())).catch(() => {});
    return;
  }
  navigator.serviceWorker.register("/service-worker.js", { type: "module" }).catch((error: unknown) => {
    // Falha de registro não quebra a operação; fica visível no console do dev.
    console.warn("service worker não registrado:", error);
  });
}
